import { IonModal, IonSpinner } from '@ionic/react';
import React, { ReactNode, useState } from 'react';
import ModalHeader from './ModalHeader';

let nextDialogId = 0;

type Props = {
  isOpen: boolean;
  title: string;
  icon?: string;
  children: ReactNode;
  onDismiss: () => void;
  onConfirm: () => void;
  confirmLabel: string;
  cancelLabel?: string;
  busy?: boolean;
};

export default function ModalDialog({ isOpen, title, icon, children, onDismiss, onConfirm, confirmLabel, cancelLabel, busy = false }: Props) {
  const [titleId] = useState(() => `xeguei-dialog-title-${++nextDialogId}`);
  return (
    <IonModal aria-labelledby={titleId} className="xeguei-dialog" isOpen={isOpen} canDismiss={!busy} backdropDismiss={!busy} onDidDismiss={onDismiss}>
      <div className="xeguei-dialog-panel">
        <ModalHeader title={title} titleId={titleId} icon={icon} layout="compact" onDismiss={onDismiss} disabled={busy} />
        <div className="xeguei-dialog-body">{children}</div>
        <footer className="xeguei-dialog-footer">
          {cancelLabel && <button type="button" className="xeguei-modal-secondary" disabled={busy} onClick={onDismiss}>{cancelLabel}</button>}
          <button type="button" className="xeguei-modal-primary" disabled={busy} onClick={onConfirm}>
            {busy && <IonSpinner name="crescent" />} {busy ? 'Aguarde...' : confirmLabel}
          </button>
        </footer>
      </div>
    </IonModal>
  );
}
